<template>
  <div class="div-page">
    <div class="container">
      <div style="background-color:#F0F2F5">
        <parking-map :key="timeRefusr" ref="Carplate"></parking-map>
      </div>
    </div>
  </div>
</template>

<script>
import ParkingMap from "../components/ParkingMap";

export default {
  data() {
    return {
      timeRefusr: new Date().getTime(),
      addressList: []
    };
  },
  components: {
    ParkingMap
  },
  mounted() {
    // this.ParkId=this.$utils.getUrlKey('id');
  },
  methods: {}
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.div-page {
  /* 单个页面 */
  --theme-color: #1966ff;

  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  overflow: auto;
  background-color: #f6f6f6;
}
.container {
  /* 容器 */
  width: 100%;
  height: 100%;
  overflow-y: scroll;
  /* padding: 0 12px 20px; */
  box-sizing: border-box;
}

/*iPhone X 适配*/
@media only screen and (device-width: 375px) and (device-height: 812px) and (-webkit-device-pixel-ratio: 3) {
  .container {
    /* 容器 */
    width: 100% !important;
    height: calc(100% - 37px) !important;
    padding: 0 12px !important;
    box-sizing: border-box !important;
  }
}
/*iPhone XS max 适配*/
@media only screen and (device-width: 414px) and (device-height: 896px) and (-webkit-device-pixel-ratio: 3) {
  .container {
    /* 容器 */
    width: 100% !important;
    height: calc(100% - 37px) !important;
    padding: 0 12px !important;
    box-sizing: border-box !important;
  }
}
/*iPhone XR max 适配*/
@media only screen and (device-width: 414px) and (device-height: 896px) and (-webkit-device-pixel-ratio: 2) {
  .container {
    /* 容器 */
    width: 100% !important;
    height: calc(100% - 37px) !important;
    padding: 0 12px !important;
    box-sizing: border-box !important;
  }
}
</style>



// WEBPACK FOOTER //
// src/views/index.vue